import React from 'react';
import { HStack, useRadioGroup } from '@chakra-ui/react';

import RadioCard from './RadioCard';

const ForecastOptions = (props) => {
    const { forecastTypes, onForecastSelect } = props;

    const { getRootProps, getRadioProps } = useRadioGroup({
        name: 'forecastType',
        defaultValue: forecastTypes[0],
        onChange: onForecastSelect,
    });

    const group = getRootProps()

    return (
        <div
            className="forecast-options"
            style={{
                position: 'absolute',
                bottom: 86,
                display: 'flex',
                justifyContent: 'center',
                width: '100%'
            }}
        >
            <HStack {...group} gap={4} zIndex={99}>
                {forecastTypes.map((value) => {
                    const radio = getRadioProps({ value })
                    return (
                    <RadioCard key={value} {...radio}>
                        {value}
                    </RadioCard>
                    )
                })}
            </HStack>
        </div>
    );
};

export default ForecastOptions;
